import { AfterViewInit, Component, OnInit } from '@angular/core';

import { EventService } from '../core/services/event.service';

import { NavigationStart, Router } from '@angular/router';
import { AllowNotificationService } from '@app/core/services/allow-notification.service';
import { NotificationTasksService } from '@app/services/notification-settings';
import { NotificationPermission } from 'common/enums';
import { Observable, Subscription, interval, of, take, tap } from 'rxjs';
import {
  LAYOUT_HORIZONTAL,
  LAYOUT_MODE,
  LAYOUT_VERTICAL,
  LAYOUT_WIDTH,
  SIDEBAR_TYPE,
  TOPBAR
} from './layouts.model';
import { AuthenticationService } from '@app/core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false
})

export class LayoutComponent implements OnInit, AfterViewInit {

  layoutType: string;
  layoutwidth: string;
  topbar: string;
  mode: string;
  sidebartype: string;

  isNotificationOpen = false;

  public isNotifiationObs: Observable<boolean> = of(false);
  private subs = new Subscription();

  constructor(
    private eventService: EventService,
    private router: Router,
    private allowNotification: AllowNotificationService,
    private authService: AuthenticationService,
    private notificationTasksService: NotificationTasksService,
    private auth: AuthenticationService
  ) {
    // this.addNotificationSubs();
  }

  addNotificationSubs = () => {
    const sub1 = this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.checkHasNotification();
      }
    });
    this.subs.add(sub1);

    const sub2 = this.notificationTasksService.notificationTaskSubject.subscribe(() => {
      this.checkHasNotification();
    });
    this.subs.add(sub2);

    const sub3 = interval(2 * 60 * 1000).pipe(
      tap(() => { this.checkHasNotification(); })
    ).subscribe();
    this.subs.add(sub3);
  }

  ngOnInit() {

    // this.allowNotification.checkForNotification();
    // this.checkHasNotification();

    // default settings
    this.layoutType = LAYOUT_VERTICAL;
    this.layoutwidth = LAYOUT_WIDTH;
    this.topbar = TOPBAR;
    this.mode = LAYOUT_MODE;
    this.sidebartype = SIDEBAR_TYPE;

    // document.body.setAttribute('data-layout-mode', this.mode);

    // listen to event and change the layout, theme, etc
    this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;
    });

    this.LayoutWidth(this.layoutwidth);

    this.eventService.subscribe('changeWidth', (width) => {
      this.layoutwidth = width;
      this.LayoutWidth(this.layoutwidth);
    });

    // listen to event and change the layout, theme, etc
    this.eventService.subscribe('changeSidebartype', (layout) => {
      this.sidebartype = layout;
      this.changeSidebar(this.sidebartype);
    });

    // Change Mode
    this.eventService.subscribe('changeMode', (mode) => {
      this.mode = mode;
      this.changeMode(this.mode);
    });

    this.changeSidebar(this.sidebartype);
    this.changeMode(this.mode);

    this.authService.currentUserObs.pipe(take(1)).subscribe((user) => {
      if (user && user.isFirstLogin) {
        this.confirmCompleteProfile();
      }
    });

  }

  public get isNotificationDenied() {
    return this.allowNotification.permission === NotificationPermission.denied;
  }

  showNotificationGuide() {
    this.allowNotification.showNotificationGuide();
  }

  openCloseNotification() {
    this.isNotificationOpen = !this.isNotificationOpen;
  }

  private checkHasNotification() {
    this.isNotifiationObs = this.notificationTasksService.hasMyNotificationTask();
  }

  // Theme Drk Light Mode
  changeMode(value) {
    switch (value) {
      case "light":
        document.body.setAttribute('data-layout-mode', 'light');
        break;
      case "dark":
        document.body.setAttribute('data-layout-mode', 'dark');
        break;
      default:
        document.body.setAttribute('data-layout-mode', 'light');
        break;
    }
  }

  changeSidebar(value) {
    switch (value) {
      case "light":
        document.body.setAttribute('data-sidebar', 'light');
        document.body.setAttribute('data-topbar', 'dark');
        document.body.removeAttribute('data-sidebar-size');
        document.body.removeAttribute('data-layout-size');
        document.body.removeAttribute('data-keep-enlarged');
        document.body.classList.remove('vertical-collpsed');
        document.body.removeAttribute('data-layout-scrollable');
        break;
      case "compact":
        document.body.setAttribute('data-sidebar-size', 'small');
        document.body.setAttribute('data-sidebar', 'dark');
        document.body.removeAttribute('data-topbar');
        document.body.removeAttribute('data-layout-size');
        document.body.removeAttribute('data-keep-enlarged');
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
        document.body.removeAttribute('data-layout-scrollable');
        break;
      case "dark":
        document.body.setAttribute('data-sidebar', 'dark');
        document.body.removeAttribute('data-topbar');
        document.body.removeAttribute('data-layout-size');
        document.body.removeAttribute('data-keep-enlarged');
        document.body.removeAttribute('data-sidebar-size');
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
        document.body.removeAttribute('data-layout-scrollable');
        break;
      case "icon":
        document.body.classList.add('vertical-collpsed');
        document.body.setAttribute('data-sidebar', 'dark');
        document.body.removeAttribute('data-layout-size');
        document.body.setAttribute('data-keep-enlarged', "true");
        document.body.removeAttribute('data-topbar');
        document.body.removeAttribute('data-layout-scrollable');
        break;
      case "colored":
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
        document.body.setAttribute('data-sidebar', 'colored');
        document.body.removeAttribute('data-layout-size');
        document.body.removeAttribute('data-keep-enlarged');
        document.body.removeAttribute('data-topbar');
        document.body.removeAttribute('data-layout-scrollable');
        document.body.removeAttribute('data-sidebar-size');
        break;
      default:
        document.body.setAttribute('data-sidebar', 'dark');
        break;
    }
  }

  ngAfterViewInit() {
  }

  LayoutWidth(width: string) {
    switch (width) {
      case "fluid":
        document.body.setAttribute("data-layout-size", "fluid");
        document.body.classList.remove("vertical-collpsed");
        document.body.removeAttribute("data-layout-scrollable");
        break;
      case "boxed":
        document.body.setAttribute("data-layout-size", "boxed");
        document.body.classList.add("vertical-collpsed");
        document.body.removeAttribute("data-layout-scrollable");
        break;
      case "scrollable":
        document.body.removeAttribute("data-layout-size");
        document.body.setAttribute("data-layout-scrollable", "true");
        document.body.setAttribute("data-layout-size", "fluid");
        document.body.classList.remove("right-bar-enabled", "vertical-collpsed");
      default:
        document.body.setAttribute("data-layout-size", "fluid");
        break;
    }
  }

  /**
   * Check if the vertical layout is requested
   */
  isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === LAYOUT_HORIZONTAL;
  }

  private confirmCompleteProfile(): void {
    Swal.fire({
      title: 'Please complete youth worker profile',
      showCancelButton: true,
      confirmButtonText: "Let's Complete Profile",
      cancelButtonText: "Later",
      allowOutsideClick: false,
      customClass: {
        footer: 'swal-button-footer',
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-outline-secondary'
      },
      footer: `
        <a class="btn btn-sm btn-link" id="dont-show-again" href="#">
          Don't show again
        </a>
        `,
      didOpen: () => {
        document.getElementById('dont-show-again')?.addEventListener('click', (event) => {
          event.preventDefault();
          this.auth.completeFirstLogin().subscribe();
          Swal.close();
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/profile']);
      }
    });
  }



}
